import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Building_Sanction_Circular_2022_23 = () => (
  <TableStructure
    list={[
      {
        fileStoreId: "7cc09359-7288-4b72-9555-ff7e05b77ed8",
        label: "MC's Office Order No.10 of 2022-23",
        date: "19-October-2022",
        subject: "Municipal Commissioner's Office Order No.10 of 2022-23",
      },
      {
        fileStoreId: "aac531dc-21eb-4885-a11a-000e8e593384",
        label: "DG(BLDG)'s Circular No. 05 of 2022-2023",
        date: "22-June-2022",
        subject:
          "Modification of fees for retention of unauthorized structures which are and allowed by Special Officer (Bldg.) Municipal Authority in the Schedule of Rates & Chargesfor the vear 2022-2023 based on IGR valuation",
      },
    ]}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2022-23"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2022_23;
